import { ISimejiItem } from '@template/Simeji/simejiStatus.interface';
import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg<{
  color?: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
  pointer-events: none;
  z-index: -1;
`;

type Props = { data: ISimejiItem };
function SleepLeg({ data }: Props) {
  return (
    <SVG
      width="100"
      height="120"
      viewBox="0 0 100 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={data.lineColor}
    >
      {/* 앉은 발 */}
      {/* 이 발 위치 때문에 항상 다리-옷-앉은발 */}
      <path
        className="sleep-leg"
        d="M32.214 104.576C34.614 101.376 38.8807 103.909 40.714 105.576C46.5474 105.909 58.4141 106.376 59.2141 105.576C60.2141 104.576 61.7141 103.576 64.7141 103.076C67.7141 102.576 70.2141 104.576 70.2141 108.576C70.2141 112.575 65.2141 117.273 63.2141 118.273C61.2141 119.273 58.7141 118.076 56.7141 117.076C54.7141 116.076 50.7141 116.576 47.2141 116.576C43.7141 116.576 44.2141 117.273 40.714 118.273C37.214 119.273 34.9304 117.076 33.714 115.576C32.5785 114.175 29.214 108.576 32.214 104.576Z"
        fill={data.skinColor}
        stroke={data.lineColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ zIndex: 0 }}
      />
    </SVG>
  );
}

export default SleepLeg;
